package fr.frux.feature.harvestcreate

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Park
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.components.FruxCard
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.feature.harvestcreate.resources.Res
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_loading
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_plantings_count
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_reminder_label
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_rule_ask
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_rule_open
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_rule_private
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_unavailable
import fr.frux.shared.domain.model.Site
import fr.frux.shared.domain.model.SiteAccessRule
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

private val SITE_LOADING = Res.string.harvestcreate_site_loading
private val SITE_UNAVAILABLE = Res.string.harvestcreate_site_unavailable

/** Rappel du lieu visé (ADR 0035) : nom, règle d'accès et nombre de plantations. Non modifiable. */
@Composable
internal fun SiteReminderCard(
    site: Site?,
    isLoading: Boolean,
) {
    FruxCard(modifier = Modifier.fillMaxWidth()) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(
                imageVector = Icons.Outlined.Park,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.primary,
            )
            Spacer(Modifier.width(FruxSpacing.sm))
            if (site == null) {
                Text(
                    text = stringResource(if (isLoading) SITE_LOADING else SITE_UNAVAILABLE),
                    style = MaterialTheme.typography.bodyMedium,
                )
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(FruxSpacing.xs)) {
                    Text(
                        text = stringResource(Res.string.harvestcreate_site_reminder_label),
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                    Text(text = site.name, style = MaterialTheme.typography.titleSmall)
                    Text(
                        text =
                            stringResource(site.accessRule.ruleRes()) + " · " +
                                stringResource(Res.string.harvestcreate_site_plantings_count, site.plantings.size),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
        }
    }
}

private fun SiteAccessRule.ruleRes(): StringResource =
    when (this) {
        SiteAccessRule.OPEN -> Res.string.harvestcreate_site_rule_open
        SiteAccessRule.ASK -> Res.string.harvestcreate_site_rule_ask
        SiteAccessRule.PRIVATE -> Res.string.harvestcreate_site_rule_private
    }
